export enum ShiftTemplateType {
    FULFILLS_REQUIRED_SHIFT = 'Paraat',
    OTHER = 'Anders',
    EDUCATION = 'Scholing',
    RESERVE = 'Reserve',
    PLANNED_OUT = 'Uitgepland',
    REACHABLE = 'Bereikbaar',
}
